import { formatDateLocal } from "@/shared/lib/date-time";
import { DataTable, type TanstackReactTable } from "@devhop/ui";
import { EyeIcon } from "lucide-react";
import type { CustomerDTO } from "../api/client";

type CustomersTableProps = {
  isLoading: boolean;
  data: CustomerDTO[];
  offset: number;
  limit: number;
  totalCount: number;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  onView: (row: CustomerDTO) => void;
  onPaginationChange: (offset: number, limit: number) => void;
  onSortingChange: (id: string, desc: boolean) => void;
};

export function CustomersTable({
  isLoading,
  data,
  offset,
  limit,
  totalCount,
  sortBy,
  sortOrder,
  onView,
  onPaginationChange,
  onSortingChange,
}: CustomersTableProps) {
  const columns: TanstackReactTable.ColumnDef<CustomerDTO>[] = [
    {
      id: "name",
      header: "ຊື່",
      cell: ({ row }) => (
        <span className="font-medium">
          {row.original.name ?? row.original.email ?? "—"}
        </span>
      ),
    },
    {
      id: "email",
      header: "ອີເມວ",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {row.original.email ?? "—"}
        </span>
      ),
    },
    {
      id: "phoneNumber",
      header: "ເບີໂທ",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {row.original.phoneNumber ?? "—"}
        </span>
      ),
    },
    {
      id: "memberTierName",
      header: "ລະດັບສະມາຊິກ",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {row.original.memberTierName ?? "—"}
        </span>
      ),
    },
    {
      id: "createdAt",
      header: "ວັນທີສະໝັກ",
      cell: ({ row }) => (
        <span className="text-muted-foreground text-sm">
          {formatDateLocal(row.original.createdAt)}
        </span>
      ),
    },
    {
      id: "actions",
      cell: ({ row }) => (
        <button
          type="button"
          onClick={() => onView(row.original)}
          className="inline-flex items-center gap-1 text-muted-foreground text-sm hover:text-foreground"
        >
          <EyeIcon className="h-4 w-4" />
          ເບິ່ງລາຍລະອຽດ
        </button>
      ),
    },
  ];

  return (
    <DataTable<CustomerDTO, unknown>
      noDataMessage="ບໍ່ພົບລູກຄ້າ"
      isLoading={isLoading}
      columns={columns}
      data={data}
      offset={offset}
      limit={limit}
      totalCount={totalCount}
      onPaginationChange={(p) => onPaginationChange(p.offset, p.limit)}
      sortBy={sortBy}
      sortOrder={sortOrder}
      onSortingChange={(s) => {
        if (s[0]?.id === "") return;
        onSortingChange(s[0]?.id || "", s[0]?.desc || false);
      }}
    />
  );
}
